var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Fragment',[_c('BaseColumn',{staticClass:"text-right text-lg font-medium",class:_vm.columnClass},[_vm._t("default",function(){return [_c('font-awesome-icon',{staticClass:"cursor-pointer",attrs:{"icon":['fas', 'chevron-right']}})]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }